const data = {
    //柱状图颜色
    "volume.volume.color.0": "rgba(255, 15, 93,0.6)",//第一根的颜色
    "volume.volume.color.1": "rgba(21,195,34,0.6)",//第二根的颜色
    // "volume.volume.transparency": 70,    //透明度
    // "volume.volume ma.color": "#FF0000", //波浪图颜色
    // "volume.volume ma.transparency": 30, //波浪图透明度
    // "volume.volume ma.linewidth": 5,
    // "volume.show ma": true,    //是否显示
    // "volume.options.showStudyArguments": false,
    // "bollinger bands.median.color": "#33FF88",
    // "bollinger bands.upper.linewidth": 7,
    // // MACD样式
    // "MACD.MACD.color": "#F00",
    // "MACD.Signal.color": "#fe8",
    // "MACD.Histogram.color": "#0f0",
    // 'MACD.MACD.linewidth': 1,
}


export default data;